"use client";

import { usePathname } from "next/navigation";
import React, { FC, useEffect } from "react";

import { CookieKeys } from "@/enums/CookieKeys.enum";
import { useCookies } from "@/hooks/useCookies";
import { useNavigate } from "@/hooks/useNavigate";

export const withAuth = <P extends object>(
  WrappedComponent: React.ComponentType<P>
): React.ComponentType<P> => {
  const RequiresAuth: FC<P> = (props) => {
    const { push } = useNavigate();
    const { getCookie } = useCookies();
    const pathname = usePathname();

    useEffect(() => {
      const isAuthenticated = getCookie(CookieKeys.AccessToken);
      if (!isAuthenticated) {
        let queryParams = "";
        if (pathname !== "/") {
          queryParams += `?redirect-to=${pathname}`;
        }
        push(`/signin${queryParams}`);
        return;
      }
      const isEmailVerified = getCookie(CookieKeys.IsEmailVerified);
      if (isEmailVerified === "false") {
        push("/verify-email");
        return;
      }
      const type = getCookie(CookieKeys.Type);
      if (type === "null") {
        push("/onboarding");
      }
    }, [getCookie, push, pathname]);

    return <WrappedComponent {...props} />;
  };

  return RequiresAuth;
};
